import { ChangeDetectionStrategy, Component, ContentChildren, ElementRef, HostBinding, QueryList } from "@angular/core";

import { SpsTableRowComponent } from "../table-row/sps-table-row.component";

@Component({
    selector: "sps-table-body, sps-tbody",
    templateUrl: "./sps-table-body.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsTableBodyComponent {
    static readonly displayName = "sps-table-body / sps-tbody";
    static readonly props = {};

    @HostBinding("attr.role") readonly _roleAttr = "rowgroup";
    @HostBinding("class.sps-table__body") readonly _spsTableBodyClass = true;

    @ContentChildren(SpsTableRowComponent) rows: QueryList<SpsTableRowComponent>;

    constructor(public elementRef: ElementRef) {}
}
